import { CreateDtrImportInput, CreateImportsResponse } from '@/models/gen/graphql';

import { CreateDtrImportDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import { Validation } from '@/utils';
import graphApi from '@/api';

type CreateDtrImportGraphApiResponse = GraphApiResponse<typeof CreateDtrImportDocument>;

export const createTimeFrameValidator = new Validation.Validator({
  'filename!': (val: string): Validation.Validity => ({
    valid: !!val,
    defaultValue: '',
  }),
  'md5!': (val: string): Validation.Validity => ({
    valid: !!val,
    defaultValue: '',
  }),
});

const createDtrImportResponseSelector = (res: CreateDtrImportGraphApiResponse): CreateImportsResponse =>
  !res.errors ? (res?.createDtrImport as CreateImportsResponse) : undefined;

const [runCreateDtrImport] = graphApi(CreateDtrImportDocument);

const createDtrImport = async (filename: string, md5: string): Promise<CreateImportsResponse> => {
  const input: CreateDtrImportInput = { filename, md5 };

  const res = await runCreateDtrImport({ input });
  return createDtrImportResponseSelector(res);
};

export default createDtrImport;
